// A custom theme for this app
const getMyTheme = type => {
  return {
    type,
    scrollbar: type === "light" ? "rgb(192,192,192)" : "#4D6880",
    tableHighlight:
      type === "light" ? "rgba(0,0,0,0.02)" : "rgba(255,255,255,0.02)",
    linkHoverColor: type === "light" ? "rgb(0,0,0)" : "rgb(255,255,255)",
    appBackground:
      type === "light"
        ? "radial-gradient( circle 343px at 46.3% 47.5%,  rgba(242,242,242,1) 0%, rgba(241,241,241,1) 72.9% )"
        : "radial-gradient( circle farthest-corner at 10% 20%,  rgba(28,38,47,1) 0%, rgba(37,47,57,1) 90% )"
  };
};

export default getMyTheme;
